// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"2eb595b9","239":"7ce1e20b","453":"102e6db9","977":"3556ba7a"}[chunkId] + ".chunk.js";
};